import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import store from '../store'

Vue.filter('ymday', function (dataStr, pattern = 'YYYY-MM-DD') {
  if (!isNaN(dataStr)) {
    dataStr = parseInt(dataStr)
  }
  return moment(dataStr).format(pattern)
})

Vue.filter('awardName', function (tp) {
  var index = store.getters.awards.findIndex(item => {
    if (item.id === tp) {
      return item
    }
  })
  if (index >= 0) {
    console.log(index)
    return store.getters.awards[index].name
  } else {
    return tp
  }
})

Vue.filter('showQuestionIndex', function (tp) {
  let arr = [
    '一',
    '二',
    '三',
    '四',
    '五',
    '六'
  ]
  return arr[tp - 1]
})

